import React, { useContext, useMemo } from 'react';
import styles from './index.module.scss';
import center_park from '../../../../imgs/icon-park.png';
import center_ground from '../../../../imgs/icon-ground.png';
import { ShareDataContext } from '@/pages/IndustrialGreenMicBigScreen';
import { useRequest } from 'ahooks';
import {
  apiV2MicrogridOverviewGetNewEnergyExistsPost,
  apiV2MicrogridOverviewGetNewEnergyRatePost,
} from '@maxtropy/intelligent-dispath-apis-v2';
import TwoAssetsRender from './TwoAssetsRender';
import ThreeAssetsRender from './ThreeAssetsRender';
import { keepPercentTwoLine } from '@/pages/IndustrialGreenMicBigScreen/utils';
import FourAssetsRender from './FourAssetsRender';
import FiveAssetsRender from './FiveAssetsRender';

const Overview = () => {
  const { microgridId, isFullScreen, dataExit } = useContext(ShareDataContext);

  // 新能源数据
  const { data } = useRequest(
    async () => {
      const res = await apiV2MicrogridOverviewGetNewEnergyRatePost({
        id: Number(microgridId),
      });
      return res;
    },
    {
      ready: !!microgridId,
      refreshDeps: [microgridId],
      pollingInterval: 1000 * 60,
    }
  );

  const exitLength = useMemo(() => {
    const obj = {
      bsaExists: dataExit?.bsaExists ?? false,
      gridExists: dataExit?.gridExists ?? false,
      loadExists: dataExit?.loadExists ?? false,
      pvExists: dataExit?.pvExists ?? false,
      wpExists: dataExit?.wpExists ?? false,
    };
    return Object.values(obj).filter(v => v === true).length;
  }, [dataExit]);

  return (
    <div className={styles.wrapper}>
      {/* 新能源占比 */}
      <div className={styles.rate_box}>
        <div className={styles.label}>新能源占比</div>
        <div className={styles.value}>{keepPercentTwoLine(data?.newEnergyRate)}%</div>
      </div>
      {/* 微电网园区（固定） */}
      <div className={styles.center_box} style={{ top: isFullScreen ? '33%' : '30%' }}>
        <img className={styles.img_park_sty} src={center_park} alt="" />
        <img className={styles.img_ground_sty} src={center_ground} alt="" />
      </div>
      {/* 剩余光伏，风电，市电，负载，储能（最少2个，最多5个） */}
      {
        // 有2个的时候为市电和负载
        exitLength === 2 && <TwoAssetsRender data={data} />
      }
      {
        // 有3个的时候为市电和负载,和其他
        exitLength === 3 && <ThreeAssetsRender dataExit={dataExit} data={data} />
      }
      {
        // 有4个的时候
        exitLength === 4 && <FourAssetsRender dataExit={dataExit} data={data} />
      }
      {
        // 有5个的时候
        exitLength === 5 && <FiveAssetsRender dataExit={dataExit} data={data} />
      }
    </div>
  );
};

export default Overview;
